export default {
  chats: {
    'show skills': {
      events: [
        {
          tasks: [
            {
              method: 'Reply',
              data: {
                reply_markup: null,
                text: '<b>Programming Languages</b>\nPython\nJava\nJavascript\nC++'
              },
              error: false
            },
            {
              method: 'Reply',
              data: {
                reply_markup: null,
                text: '<b>Software Frameworks</b>\nReact JS\nVue JS\nAndroid App\nFlask\nDjango\nAnsible'
              },
              error: false
            },
            {
              method: 'Reply',
              data: {
                reply_markup: null,
                text: '<b>Web technologies</b>\nHTML\nCSS\nJQuery\nBootstrap\nJSON\nWebhooks\nWebsocket\nMQTT'
              },
              error: false
            }
          ]
        }
      ]
    },
    'show contact details': {
      events: [
        {
          tasks: [
            {
              method: 'EditMessageText',
              data: {
                message_id: '{{incoming_message_id}}',
                text: '<b>Telegram:</b> @JustaExample\n<b>Email:</b> just@example.com\n<b>Mobile:</b> 09900345363',
                reply_markup: null,
                chat_id: '{{user_id}}'
              },
              error: false
            }
          ]
        }
      ]
    },
    Greet: {
      events: [
        {
          tasks: [
            {
              method: 'Reply',
              data: {
                reply_markup: {
                  keyboard: [
                    [
                      {
                        text: 'See Profile',
                        id: '31030'
                      }
                    ]
                  ],
                  resize_keyboard: true
                },
                text: 'Hi {{ first_name }} welcome,\n\nI am a freelance software developer, I can help you to create your dream projects. \nCheck out my profile and if you are impressed, hire me to work for you.\n\n[ Explain what this bot does, and how to use it, This is just example. Go and edit your bot in www.thebotcreator.com]'
              },
              error: false
            }
          ]
        }
      ]
    },
    'show profile': {
      events: [
        {
          tasks: [
            {
              method: 'Reply',
              data: {
                reply_markup: {
                  keyboard: [
                    [
                      {
                        text: 'Skills',
                        id: '91530'
                      },
                      {
                        text: 'Projects',
                        id: '993095'
                      }
                    ],
                    [
                      {
                        text: 'Working Charge',
                        id: '5163'
                      },
                      {
                        text: 'Contact',
                        id: '742847'
                      }
                    ]
                  ],
                  resize_keyboard: true
                },
                text: 'I have successfully completed 7 projects in the last 2 years for my clients. '
              },
              error: false
            }
          ]
        }
      ]
    },
    'contact details confirmation': {
      events: [
        {
          tasks: [
            {
              method: 'Reply',
              data: {
                reply_markup: {
                  inline_keyboard: [
                    [
                      {
                        text: 'Yes',
                        callback_data: 'contact-details-yes',
                        id: '18183',
                        type: 'callback_data'
                      }
                    ]
                  ]
                },
                text: 'Do you want to discuss your project with me?\n\nBut please check my profile first, If you feel I am the right guy for your project then press yes.\nYou will get the contact details.'
              },
              error: false
            }
          ]
        }
      ]
    },
    'Show Projects': {
      events: [
        {
          tasks: [
            {
              method: 'Reply',
              data: {
                reply_markup: {
                  inline_keyboard: [
                    [
                      {
                        text: 'Web app with VueJS',
                        id: '38037',
                        type: 'url',
                        url: 'https://vuejsexamples.com/task-list-with-vue-js/'
                      }
                    ],
                    [
                      {
                        text: 'Restful API with Flask',
                        id: '86925',
                        type: 'url',
                        url: 'https://github.com/flask-restful/flask-restful'
                      }
                    ],
                    [
                      {
                        text: 'Dashboard using VueJS',
                        id: '98845',
                        type: 'url',
                        url: 'https://www.creative-tim.com/product/vue-material-dashboard'
                      }
                    ],
                    [
                      {
                        text: 'Image converter with Django',
                        id: '65941',
                        type: 'url',
                        url: 'https://github.com/flask-restful/flask-restful'
                      }
                    ]
                  ]
                },
                text: 'Links to some of my completed projects'
              },
              error: false
            }
          ]
        }
      ]
    },
    'show working charge': {
      events: [
        {
          tasks: [
            {
              method: 'Reply',
              data: {
                reply_markup: null,
                text: 'The charge is completely based on the complexity of the project and the working hours it takes to complete the project.\n\nYou can expect the charge to be in the range of  4$/working hour to 10$/working hour.\n\nWe can discuss and negotiate.'
              },
              error: false
            }
          ]
        }
      ]
    }
  },
  actions: {
    callbacks: [{
      button: {
        text: 'Yes',
        callback_data: 'contact-details-yes',
        id: '18183',
        type: 'callback_data'
      },
      chat: 'show contact details'
    }],
    keywords: [],
    commands: [
      {
        description: 'Start chatting with me',
        admin: false,
        error: false,
        command: 'start',
        chat: 'Greet'
      }
    ],
    reply_buttons: [
      {
        button: {
          text: 'See Profile',
          id: '31030'
        },
        chat: 'show profile'
      },
      {
        button: {
          text: 'Skills',
          id: '91530'
        },
        chat: 'show skills'
      },
      {
        button: {
          text: 'Projects',
          id: '993095'
        },
        chat: 'Show Projects'
      },
      {
        button: {
          text: 'Working Charge',
          id: '5163'
        },
        chat: 'show working charge'
      },
      {
        button: {
          text: 'Contact',
          id: '742847'
        },
        chat: 'contact details confirmation'
      }
    ]
  },
  variables: {}
};